/* External dependencies */
import { Observable, switchMap, map, from, catchError, of, mergeMap } from 'rxjs';
import { ofType } from 'redux-observable';

/* Local dependencies */
import { UpdateUserRequest, updateUserSuccessAction, UpdateUserActionTypes } from './actions';
import { updateUser } from './service';

const updateUserEpic = (action$: Observable<UpdateUserRequest>) =>
  action$.pipe(
    ofType(UpdateUserActionTypes.UPDATE_USER_REQUEST),
    switchMap((action) =>
      from(updateUser(action.payload)).pipe(
        map((user) => updateUserSuccessAction(user)),
        catchError((error) =>
          of({
            type: UpdateUserActionTypes.UPDATE_USER_ERROR,
            error,
          }),
        ),
      ),
    ),
  );

export default updateUserEpic;
